<template>
  <div class="wedding-invitation" :class="{ 'invitation-bounce':canOpen }">
    <!-- 邀请函的炫酷背景 -->
    <div class="invitation-background">
      <div v-for="n in 15" :key="'inv-particle'+n" class="invitation-particle"
           :style="{
             left: Math.random() * 100 + '%',
             top: Math.random() * 100 + '%',
             animationDelay: Math.random() * 3 + 's',
             width: (Math.random() * 8 + 3) + 'px',
             height: (Math.random() * 8 + 3) + 'px'
           }">
      </div>
    </div>
    
    <div class="invitation-container" :class="{ 'invitation-down':isOpening }">
      <div class="invitation-cover">
        <div class="cover-content" :class="{'invitation-up':isOpening}">
          <div class="content-inside">
            <!-- 轮播图区域 -->
            <div class="photo-carousel">
              <div class="carousel-container" :style="{ transform: 'translateX(-' + currentIndex * 100 + '%)' }">
                <div v-for="(photo, index) in photoList" :key="index" class="carousel-item">
                  <img :src="photo" class="carousel-photo">
                </div>
              </div>
              
              <!-- 左右箭头 -->
              <button class="carousel-arrow left-arrow" @click="prevPhoto" v-if="photoList.length > 1">❮</button>
              <button class="carousel-arrow right-arrow" @click="nextPhoto" v-if="photoList.length > 1">❯</button>
              
              <!-- 小圆点指示器 -->
              <div class="carousel-dots">
                <span v-for="(photo, index) in photoList" :key="index" 
                      class="dot" 
                      :class="{ 'active': currentIndex === index }"
                      @click="currentIndex = index">
                </span>
              </div>
            </div>
            
            <p class="glowing-text">我们结婚啦！</p>
            <p class="glowing-text"><b>孙诺 & 崔舒箫</b></p>
            <p class="glowing-text">时间：2026年5月4日</p>
            <p class="glowing-text">地点：<b>白银区金凤凰酒店【人民路88号】</b></p>
            
            <!-- 弹幕输入区域 - 纯净版本 -->
            <div class="content-inside-bless">
              <input
                type="text"
                placeholder="写下你的祝福"
                v-model="wish"
                ref="wishInput"
                @focus="isFocused = true"
                @blur="isFocused = false, hasEntered = false"
                @keyup.enter="sendBarrage"
              >
              <p v-if="!wish && isFocused && hasEntered" class="warning-text">请输入祝福哦</p>
              <div>
                <button @click="sendBarrage" class="glow-button">发送祝福弹幕</button>
                <button @click="closeInvitation" class="glow-button">关闭</button>
              </div>
            </div>
          </div>
        </div>
        <div class="cover-inside-left" :class="{'opening':isOpening}"></div>
        <div class="cover-inside-right" :class="{'opening':isOpening}"></div>
        <img class="cover-inside-seal" src="../images/seal.png" @click="openInvitation" :class="{'invitation-flight':isOpening}">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    canOpen: {
      type: Boolean,
      default: false
    }
  },
  data() {
    // 直接用 1-16
    const selectedPhotos = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16]

    const photoList = []
    for (let i = 0; i < selectedPhotos.length; i++) {
      const photoNumber = selectedPhotos[i]
      photoList.push(require(`../images/wedding-photos/photo${photoNumber}.jpg`))
    }
      
    return {
      isOpening: false,
      wish: '',
      isFocused: false,
      hasEntered: false,
      currentIndex: 0,
      photoList: photoList,
      autoPlayTimer: null
    }
  },
  watch: {
    canOpen(newVal) {
      console.log('canOpen changed to:', newVal)
      if (newVal) {
        console.log('Opening invitation...')
      }
    }
  },
  mounted() {
    console.log('Invitation mounted, canOpen:', this.canOpen)
    this.startAutoPlay()
  },
  beforeDestroy() {
    this.stopAutoPlay()
  },
  methods: {
    openInvitation(){
      console.log('openInvitation called')
      this.isOpening = true
    },
    closeInvitation () {
      this.isOpening = false
      this.stopAutoPlay()
      setTimeout(() => {
        this.$emit('onClose')
      }, 660)
    },
    // 弹幕发送逻辑
    sendBarrage(){
      this.$nextTick(() => {
        this.hasEntered = true
        if (!this.wish) {
          return
        }
        this.isOpening = false
        this.$refs.wishInput.blur()
        setTimeout(() => {
          this.$emit('sendBarrage', this.wish)
          this.wish = ''  // 清空输入框
        }, 660)
      })
    },
    nextPhoto() {
      if (this.currentIndex < this.photoList.length - 1) {
        this.currentIndex++
      } else {
        this.currentIndex = 0
      }
    },
    prevPhoto() {
      if (this.currentIndex > 0) {
        this.currentIndex--
      } else {
        this.currentIndex = this.photoList.length - 1
      }
    },
    startAutoPlay() {
      this.autoPlayTimer = setInterval(() => {
        this.nextPhoto()
      }, 3000)
    },
    stopAutoPlay() {
      if (this.autoPlayTimer) {
        clearInterval(this.autoPlayTimer)
      }
    }
  }
}
</script>

<style lang="less">
  .wedding-invitation{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    padding: 30px 20px;
    padding-top: 60px;
    z-index: 100;
    transform: scale(0.05);
    -webkit-transform: scale(0.05);
    opacity: 0;
    transition: transform 0.8s cubic-bezier(.26,1.84,.39,.61), opacity 0.5s linear;
    -webkit-transition: -webkit-transform 0.8s cubic-bezier(.26,1.84,.39,.61), opacity 0.5s linear;
    background: transparent;
    overflow: hidden;
    
    &.invitation-bounce{
      opacity: 1;
      transform: scale(1);
      -webkit-transform: scale(1);
    }
    
    // 邀请函的炫酷背景
    .invitation-background {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: radial-gradient(circle at 50% 50%, 
                                  rgba(255, 69, 0, 0.3) 0%,
                                  rgba(255, 215, 0, 0.2) 50%,
                                  transparent 100%);
      animation: neonGlow 6s ease infinite;
      z-index: 1;
      pointer-events: none;
      
      .invitation-particle {
        position: absolute;
        background: rgba(255, 215, 0, 0.8);
        border-radius: 50%;
        box-shadow: 0 0 30px rgba(255, 215, 0, 0.9);
        animation: particleTwinkle 2s ease-in-out infinite;
      }
    }
    
    .invitation-container{
      position: relative;
      width: 100%;
      height: 100%;
      transition: transform 0.6s cubic-bezier(0.4, 0, 1, 1);
      -webkit-transition: -webkit-transform 0.6s cubic-bezier(0.4, 0, 1, 1);
      z-index: 10;
      
      &.invitation-down{
        transform: translateY(20px);
        -webkit-transform: translateY(20px);
      }
      
      .invitation-cover{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: linear-gradient(135deg, #D65047, #B03A3A);
        border-radius: 10px;
        perspective: 500px;
        box-shadow: 0 0 30px rgba(255, 215, 0, 0.5);
        
        .cover-content{
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          padding: 10px 20px;
          transition: transform 0.6s cubic-bezier(0.4, 0, 1, 1);
          -webkit-transition: -webkit-transform 0.6s cubic-bezier(0.4, 0, 1, 1);
          
          &.invitation-up{
            transform: translateY(-60px);
            -webkit-transform: translateY(-60px);
          }
          
          .content-inside{
            height: 100%;
            padding: 20px;
            color: #a9895d;
            background: rgba(255, 241, 222, 0.95);
            text-align: center;
            overflow: auto;
            border-radius: 8px;
            box-shadow: inset 0 0 30px rgba(255, 215, 0, 0.3);
            
            // 轮播图样式
            .photo-carousel {
              position: relative;
              width: 100%;
              margin-bottom: 15px;
              overflow: hidden;
              border-radius: 8px;
              background-color: #FFF1DE;
              
              .carousel-container {
                display: flex;
                transition: transform 0.5s ease;
                
                .carousel-item {
                  flex: 0 0 100%;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  background-color: #FFF1DE;
                  min-height: 220px;
                  
                  .carousel-photo {
                    max-width: 100%;
                    max-height: 220px;
                    width: auto;
                    height: auto;
                    object-fit: contain;
                    border-radius: 8px;
                    border: 2px solid #FFD700;
                    background-color: #FFF1DE;
                  }
                }
              }
              
              .carousel-arrow {
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
                width: 30px;
                height: 30px;
                border: none;
                border-radius: 50%;
                background: rgba(255, 215, 0, 0.8);
                color: #722F37;
                font-size: 20px;
                cursor: pointer;
                z-index: 10;
                transition: all 0.3s ease;
                
                &:hover {
                  background: #FFD700;
                  transform: translateY(-50%) scale(1.1);
                }
                
                &.left-arrow {
                  left: 10px;
                }
                
                &.right-arrow {
                  right: 10px;
                }
              }
              
              .carousel-dots {
                position: absolute;
                bottom: 10px;
                left: 50%;
                transform: translateX(-50%);
                display: flex;
                gap: 8px;
                z-index: 10;
                
                .dot {
                  width: 8px;
                  height: 8px;
                  border-radius: 50%;
                  background: rgba(255, 255, 255, 0.5);
                  cursor: pointer;
                  transition: all 0.3s ease;
                  
                  &.active {
                    background: #FFD700;
                    transform: scale(1.2);
                  }
                }
              }
            }
            
            .glowing-text {
              animation: goldenPulse 3s ease-in-out infinite;
              margin-top: 0;
              margin-bottom: 5px;
            }
            
            .content-inside-bless{
              input{
                width: 100%;
                height: 40px;
                margin-bottom: 10px;
                padding: 0 15px;
                outline: none;
                border: 2px solid #FFD700;
                border-radius: 25px;
                background: rgba(255, 241, 222, 0.7);
                color: #722F37;
                font-size: 14px;
                transition: all 0.3s ease;
                
                &::placeholder {
                  color: rgba(169, 137, 93, 0.6);
                  font-size: 14px;
                  text-align: center;
                  letter-spacing: 1px;
                }
                
                &:focus {
                  border-color: #FF4500;
                  background: rgba(255, 241, 222, 0.95);
                  box-shadow: 0 0 15px rgba(255, 215, 0, 0.3);
                  transform: scale(1.02);
                }
              }
              
              .warning-text {
                color: #FF4500;
                animation: pulse 1s ease-in-out infinite;
              }
              
              >div{
                display: flex;
                gap: 10px;
                
                .glow-button {
                  flex: 1;
                  height: 40px;
                  color: #722F37;
                  background: linear-gradient(135deg, #FFD700, #FFA500);
                  border: none;
                  outline: none;
                  border-radius: 20px;
                  font-weight: bold;
                  cursor: pointer;
                  transition: all 0.3s ease;
                  box-shadow: 0 2px 10px rgba(255, 215, 0, 0.3);
                  
                  &:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 5px 15px rgba(255, 215, 0, 0.5);
                  }
                  
                  &:active {
                    transform: translateY(0);
                  }
                  
                  &:last-child {
                    background: transparent;
                    border: 2px solid #FFD700;
                    color: #FFD700;
                    flex: 0.4;
                  }
                }
              }
            }
          }
        }
        
        .cover-inside-left{
          position: absolute;
          left: 0;
          top: 0;
          width: 70%;
          height: 100%;
          border-radius: 10px;
          background: linear-gradient(135deg, #D65047, #B03A3A);
          box-shadow: 5px 0 20px rgba(0,0,0,0.3);
          z-index: 6;
          transition: transform 0.5s;
          -webkit-transition: -webkit-transform 0.5s;
          transform-origin: 0 50%;
          -webkit-transform-origin: 0 50%;
          
          &.opening{
            transform: rotate3d(0,1,0,-140deg);
            -webkit-transform: rotate3d(0,1,0,-140deg);
          }
        }
        
        .cover-inside-right{
          position: absolute;
          right: 0;
          top: 0;
          width: 40%;
          height: 100%;
          border-radius: 10px;
          background: linear-gradient(135deg, #D65047, #B03A3A);
          box-shadow: -5px 0 20px rgba(0,0,0,0.3);
          z-index: 5;
          transition: transform 0.5s;
          -webkit-transition: -webkit-transform 0.5s;
          transform-origin: 100% 50%;
          -webkit-transform-origin: 100% 50%;
          
          &.opening{
            transform: rotate3d(0,1,0,140deg);
            -webkit-transform: rotate3d(0,1,0,140deg);
          }
        }
        
        .cover-inside-seal{
          position: absolute;
          left: 70%;
          bottom: 100px;
          width: 80px;
          height: 80px;
          margin-left: -40px;
          z-index: 7;
          transform-origin: 50% 50%;
          -webkit-transform-origin: 50% 50%;
          transition: all 0.8s cubic-bezier(0.4, 0, 1, 1);
          -webkit-transition: all 0.8s cubic-bezier(0.4, 0, 1, 1);
          filter: drop-shadow(0 0 10px gold);
          
          &.invitation-flight{
            opacity: 0;
            transform: scale(2);
          }
        }
      }
    }
  }
</style>